export default __webpack_public_path__ + "static/107982-48aa87722008b4b41f039d087a8bdc8a.jpg";